import { render, staticRenderFns } from "./ListOfFiles.vue?vue&type=template&id=906792f4&"
import script from "./ListOfFiles.vue?vue&type=script&lang=js&"
export * from "./ListOfFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports